import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {AuthConsumer} from "../context/AuthContext";

const ProtectedRoute = ({component: Component, ...rest}) => (
    <AuthConsumer>
        {({isLoggedIn}) => (isLoggedIn ? <Component {...rest} /> : <div>Loading...</div>)}
    </AuthConsumer>
);

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/components/pages/ProtectedRoute.js